import makeStyles from "@mui/styles/makeStyles";

export const useDialogStyles = makeStyles((theme) => ({
  container: {
    maxWidth: "100vw",
    alignItems: "flex-end",
    [theme.breakpoints.up("md")]: {
      alignItems: "center",
    },
  },
  paper: {
    width: "100%",
    maxHeight: "100%",
    margin: 0,
    padding: "0px !important",
    borderRadius: "8px 8px 0 0",
    [theme.breakpoints.up("md")]: {
      width: "calc(100% - 64px)",
      maxHeight: "calc(100% - 64px)",
      margin: "32px",
      borderRadius: 8,
    },
  },
  paperWidthMd: {
    height: "100vh",
    margin: 0,
    borderRadius: 0,
    [theme.breakpoints.up("md")]: {
      width: 806,
      height: "80vh",
      margin: 0,
    },
  },
  paperFullScreen: {
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 0,
    height: "100vh",
    width: "100%",
    maxWidth: "100%",
    maxHeight: "100%",
    margin: 0,
    backgroundColor: theme.palette.grey["200"],
    [theme.breakpoints.up("md")]: {
      height: "100vh",
    },
  },
}));
